import React from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import LocationMap from './LocationMap/LocationMap';

import * as styles from './Location.module.scss';

export default function Location({ title, info }) {
  return (
    <Container id="findUs">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <section className={styles.info}>
          {info?.map(({ title, subtitle, description, phone }) => (
            <article key={title} className={styles.infoItem}>
              <Title className={styles.infoTitle} tag="h3" size="h5" color="white">
                {title}
              </Title>
              <p className={styles.infoDescription}>{subtitle}</p>
              {description && <p className={styles.infoDescription}>{description}</p>}
              {phone && (
                <a className={styles.infoDescription} href={`tel:${phone.number}`}>
                  {phone.label}
                </a>
              )}
            </article>
          ))}
        </section>
        <LocationMap className={styles.mapSection} />
      </div>
    </Container>
  );
}
